import React from 'react'
import AuthPage from '../Auth/AuthPage'

// Student entry point — the shared screen lives in Components/Auth/AuthPage.
const TempLogin = () => <AuthPage role="student" />

export default TempLogin
